import {
  Printer,
  PrinterPagination,
  PrintJob,
  PrintJobFilters
} from '../../interfaces/printer.interface';

export class LoadPrinters {
  static readonly type = '[Printers] Load Printers';
}

export class LoadPrintersSuccess {
  static readonly type = '[Printers] Load Printers Success';
  constructor(public printers: Printer[]) {}
}

export class LoadPrintersFailure {
  static readonly type = '[Printers] Load Printers Failure';
  constructor(public error: string) {}
}

export class SelectPrinter {
  static readonly type = '[Printers] Select Printer';
  constructor(public printerId: number) {}
}

export class SelectPrinterSuccess {
  static readonly type = '[Printers] Select Printer Success';
  constructor(public printer: Printer) {}
}

export class SelectPrinterFailure {
  static readonly type = '[Printers] Select Printer Failure';
  constructor(public error: string) {}
}

export class LoadPrintJobs {
  static readonly type = '[Printers] Load Print Jobs';
  constructor(public printerId: number, public filters: PrintJobFilters) {}
}

export class LoadPrintJobsSuccess {
  static readonly type = '[Printers] Load Print Jobs Success';
  constructor(
    public data: { print_jobs: PrintJob[]; pagination: PrinterPagination }
  ) {}
}

export class LoadPrintJobsFailure {
  static readonly type = '[Printers] Load Print Jobs Failure';
  constructor(public error: string) {}
}

export class ReprintJob {
  static readonly type = '[Printers] Reprint Job';
  constructor(public printerId: number, public jobId: number) {}
}

export class ReprintJobSuccess {
  static readonly type = '[Printers] Reprint Job Success';
  constructor(public message: string) {}
}

export class ReprintJobFailure {
  static readonly type = '[Printers] Reprint Job Failure';
  constructor(public error: string) {}
}

export class ReprintBatch {
  static readonly type = '[Printers] Reprint Batch';
  constructor(public printerId: number, public batchId: number) {}
}

export class ReprintBatchSuccess {
  static readonly type = '[Printers] Reprint Batch Success';
}

export class ReprintBatchFailure {
  static readonly type = '[Printers] Reprint Batch Failure';
  constructor(public error: string) {}
}

export class RefreshPrinterStatus {
  static readonly type = '[Printers] Refresh Printer Status';
}

export class RefreshPrinterStatusSuccess {
  static readonly type = '[Printers] Refresh Printer Status Success';
  constructor(public printers: any[]) {}
}

export class RefreshPrinterStatusFailure {
  static readonly type = '[Printers] Refresh Printer Status Failure';
  constructor(public error: string) {}
}

export class UpdateFilters {
  static readonly type = '[Printers] Update Filters';
  constructor(public filters: PrintJobFilters) {}
}

export class ClearSelectedPrinter {
  static readonly type = '[Printers] Clear Selected Printer';
}

export class ClearPrintJobs {
  static readonly type = '[Printers] Clear Print Jobs';
}

export class ClearError {
  static readonly type = '[Printers] Clear Error';
}
